<template>
  <div>
    <div class="header">
      <!--      <img class="logo" :src="UserInfo.logoUrl" alt="">-->
      <img class="logo" src="@/assets/images/logo.png" alt="">
    </div>
  </div>
</template>



<script>


export default {
  data() {
    return {
      show: false,
      flag: false,
      name: 'transfer'
    }
  },
  props: ['HideForm', 'Params', 'UserInfo'],
  methods: {
    ChangeShow() {
      this.show = !this.show
    },
    choose_pay(methods) {
      this.show = false
      this.$emit("form", methods)
      this.name = methods
      //this.flag = true
    },
    close() {
      this.flag = false
      this.show = false
    }
  },
  watch: {
    HideForm(val) {
      if (!val) {
        // this.close()
        this.show = true
        this.$emit('changeStatus')
      }

    }
  }
}
</script>

<style scoped lang="scss">
.header {
  text-align: left;
  height: 0.96rem;

  @media (min-width: 1000px) {
    display: none !important;
  }

  .title-text {
    font-size: 0.3rem;
    font-weight: bold;
    color: #333;
  }

  h1 {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #282E34;
  }

  .logo {
    height: 0.75rem;
    /*height: 0.8rem;*/
  }
}

</style>



// WEBPACK FOOTER //
// src/components/header.vue